import { createContext } from "react";
import { Currency, currencies } from "../OrderContext/OrderContext";

const CurrencyContext = createContext<Currency>(currencies.USD);

export default CurrencyContext;
